import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { AuthService } from './auth/auth.service';
import { ConnectionService } from 'ng-connection-service';

// 👇 Import Angular Idle Modules
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'HelloWorld';
  isLoggedIn: any;
  status = 'ONLINE';
  isConnected = true;

  constructor(
    private idle: Idle,
    private keepalive: Keepalive,
    private snackBar: MatSnackBar,
    private router: Router,
    private authService: AuthService,
    private connectionService: ConnectionService
  ) {
    // 🔹 Monitor Internet Connection
    this.connectionService.monitor().subscribe(isConnected => {
      this.isConnected = isConnected;
      if (this.isConnected) {
        this.status = 'ONLINE';
        this.snackBar.open('You are Online', 'x', {
          duration: 5000,
          panelClass: ['green-snackbar']
        });
      } else {
        this.status = 'OFFLINE';
        this.snackBar.open('You are OFFLINE, Please check your internet connection', 'x', {
          duration: 15000,
          panelClass: ['warning']
        });
      }
    });

    // 🔹 Idle timeout configuration
    this.idle.setIdle(1200); // 20 minutes = 1200 seconds of inactivity
    this.idle.setTimeout(30); // 30-second countdown before logout
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    // 🔹 Handle timeout event
    this.idle.onTimeout.subscribe(() => {
      if (this.authService.isLoggedIn()) {
        this.logOut();
        alert('Session Expired, Please Re-Login to continue');
      }
    });

    // 🔹 Start watching
    this.idle.watch();

    // (Optional) Keepalive ping setup
    this.keepalive.interval(15 * 60); // every 15 minutes
  }

  ngOnInit() {
    this.isLoggedIn = sessionStorage.getItem('isLoggedIn');
  }

  logOut() {
    this.authService.logout().subscribe(response => {
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['']);
    }, error => {
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['']);
    });
  }
}
